import { Card, CardContent } from "@/components/ui/card";
import { fmtDateTime } from "./utils";

/** Tab "Histórico" — read-only audit trail (newest first). */
export default function HistoricoTab({ cs }) {
  const entries = (cs.audit_log || []).slice().reverse();
  return (
    <Card><CardContent className="p-6 space-y-2">
      {entries.length === 0 && <div className="text-sm text-slate-500">Sem histórico.</div>}
      {entries.map((a, i) => (
        <div key={`${a.timestamp || ""}-${a.field || ""}-${i}`} className="border-l-2 border-blue-600 pl-3 text-sm">
          <div className="font-medium">
            {a.field}
            {a.old_value && a.new_value && (
              <span className="text-slate-400 font-normal"> — {JSON.stringify(a.old_value)} → {JSON.stringify(a.new_value)}</span>
            )}
          </div>
          <div className="text-xs text-slate-500">{fmtDateTime(a.timestamp)} · {a.user_name} {a.reason && `· ${a.reason}`}</div>
        </div>
      ))}
    </CardContent></Card>
  );
}
